import { render, staticRenderFns } from "./HotelsMapActions.vue?vue&type=template&id=8605d862&scoped=true&"
import script from "./HotelsMapActions.vue?vue&type=script&lang=js&"
export * from "./HotelsMapActions.vue?vue&type=script&lang=js&"
import style0 from "./HotelsMapActions.vue?vue&type=style&index=0&id=8605d862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8605d862",
  null
  
)

export default component.exports